// export type MarginSize = "xs" | "sm" | "md" | "lg" | "xl" | "xxl";
// export type PaddingSize = "xs" | "sm" | "md" | "lg" | "xl" | "xxl";

// export type MarginType = "m" | "mx" | "my" | "ml" | "mr" | "mt" | "mb";

// type MarginMapping = {
//   [key in MarginType]: MarginSize;
// };

// export type MarginSizeMapping<Type> = {
//   -readonly [Property in keyof Type]: Type[Property];
// };

// export type MarginProps = MarginSizeMapping<MarginMapping>;

import { tv } from "@/utils/tv.config";
import { Ref, RefObject, useImperativeHandle, useRef } from "react";

export const marginVariants = tv({
  base: "",
  variants: {
    m: {
      xs: "m-2",
      sm: "m-4",
      md: "m-6",
      lg: "m-8",
      xl: "m-10",
      xxl: "m-12",
    },
    mx: {
      xs: "mx-2",
      sm: "mx-4",
      md: "mx-6",
      lg: "mx-8",
      xl: "mx-10",
      xxl: "mx-12",
      "mx-auto": "mx-auto",
    },
    my: {
      xs: "my-2",
      sm: "my-4",
      md: "my-6",
      lg: "my-8",
      xl: "my-10",
      xxl: "my-12",
    },
    ml: {
      xs: "ml-2",
      sm: "ml-4",
      md: "ml-6",
      lg: "ml-8",
      xl: "ml-10",
      xxl: "ml-12",
    },
    mr: {
      xs: "mr-2",
      sm: "mr-4",
      md: "mr-6",
      lg: "mr-8",
      xl: "mr-10",
      xxl: "mr-12",
    },
    mt: {
      xs: "mt-2",
      sm: "mt-4",
      md: "mt-6",
      lg: "mt-8",
      xl: "mt-10",
      xxl: "mt-12",
    },
    mb: {
      xs: "mb-2",
      sm: "mb-4",
      md: "mb-6",
      lg: "mb-8",
      xl: "mb-10",
      xxl: "mb-12",
    },
  },
});

export const WidthMapping = tv({
  base: "",
  variants: {
    xs: {
      true: "max-w-xs",
    },
    sm: {
      true: "max-w-sm",
    },
    md: {
      true: "max-w-md",
    },
    lg: {
      true: "max-w-lg",
    },
    xl: {
      true: "max-w-xl",
    },
    xxl: {
      true: "max-w-2xl",
    },
  },
  defaultVariants: {
    md: true,
  },
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AnyObject = { [key: string]: any };

//Next ui chared types start
export interface AriaLabelingProps {
  /**
   * Defines a string value that labels the current element.
   */
  "aria-label"?: string;

  /**
   * Identifies the element (or elements) that labels the current element.
   */
  "aria-labelledby"?: string;

  /**
   * Identifies the element (or elements) that describes the object.
   */
  "aria-describedby"?: string;

  /**
   * Identifies the element (or elements) that provide a detailed, extended description for the object.
   */
  "aria-details"?: string;
}
// A set of common DOM props that are allowed on any component
// Ensure this is synced with DOMPropNames in filterDOMProps
export interface DOMProps {
  /**
   * The element's unique identifier. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id).
   */
  id?: string;
}
export type AnchorOrientation = "top" | "right" | "bottom" | "left";
export type NoUndefinedField<T> = {
  [P in keyof T]-?: NoUndefinedField<NonNullable<T[P]>>;
};

export type Orientation = "horizontal" | "vertical";

export type As<Props = any> = React.ElementType<Props>;

export type PropsOf<T extends As> = React.ComponentPropsWithoutRef<T> & {
  component?: As;
};

export type Merge<M, N> =
  N extends Record<string, unknown> ? M : Omit<M, keyof N> & N;

export interface DOMElement extends Element, HTMLOrSVGElement {}
type DataAttributes = {
  [dataAttr: string]: any;
};
export type DOMAttributes<T = DOMElement> = React.AriaAttributes &
  React.DOMAttributes<T> &
  DataAttributes & {
    id?: string;
    role?: React.AriaRole;
    tabIndex?: number;
    style?: React.CSSProperties;
  };

export type HTMLSpocUIProps<
  T extends As = "div",
  OmitKeys extends keyof any = never,
> = Omit<
  PropsOf<T>,
  | "ref"
  | "color"
  | "slot"
  | "size"
  | "defaultChecked"
  | "defaultValue"
  | OmitKeys
> & {
  as?: As;
};

export type PropGetter<P = Record<string, unknown>, R = DOMAttributes> = (
  props?: Merge<DOMAttributes, P>,
  ref?: React.Ref<any>
) => R & React.RefAttributes<any>;

export function useDOMRef<T extends HTMLElement = HTMLElement>(
  ref?: RefObject<T | null> | Ref<T | null>
) {
  const domRef = useRef<T>(null);
  //@ts-ignore
  useImperativeHandle(ref, () => domRef.current);

  return domRef;
}

//Next ui shared types end here
